import InfiniteText from "./InfiniteText";
export default InfiniteText;
